var a = Math.max, r = Math.min, m = Math.round;
export {
  a as max,
  r as min,
  m as round
};
